'use client';
import {
  INinjaEvent,
  addEventParam,
  useQueuedEventStore
} from '@ninjacart/nc-events-sdk-v2';
import {
  IESShortVideoContent,
  IFeedLongVideoData,
  IPlayListDetail,
  IRemoteVideoMetadata,
  IVideosThreds,
  KissanEventType,
  getVideoComments,
  handleMarketingEvents,
  isInvalidPostOwnerId,
  postCommentOnVideo,
  transformStreamComment,
  uploadContentApi,
  useAppPersistenceStore,
  useFeedStore,
  useProfileStore
} from '@ninjacart/nc-nk-store';
import { IFeedOrStreamComment } from '@ninjacart/nc-nk-store/src/interface/comment';
import { FlashList } from '@shopify/flash-list';
import { MessageCircle, SendHorizontal, ThumbsUp } from '@tamagui/lucide-icons';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Keyboard,
  Platform,
  Pressable,
  View
} from 'react-native';
import { useRouter } from 'solito/navigation';
import {
  Avatar,
  Card,
  Paragraph,
  Spinner,
  Stack,
  Text,
  TextArea,
  XStack,
  YStack,
  useTheme
} from 'tamagui';
import { useTimeAgo } from './useTimeAgo';
export const CommentSection = ({
  feedDetail,
  bottom,
  threads,
  setCommentsCount,
  commentsCount,
  useKeyBoardHeight = false,
  itemType = '',
  index,
  commentbottomSheet,
  setCommentbottomSheet
}: {
  feedDetail?: IFeedLongVideoData | IRemoteVideoMetadata | IESShortVideoContent | IPlayListDetail;
  bottom?: any;
  threads?: IFeedOrStreamComment[];
  setCommentsCount?: any;
  useKeyBoardHeight?: Boolean;
  commentsCount?: number;
  itemType?: string;
  index?: number;
  commentbottomSheet?: boolean;
  setCommentbottomSheet?: (commentbottomSheet: boolean) => void;
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [addcomment, setComment] = useState<string>('');
  const textAreaRef = useRef<TextArea>(null);
  const appLanguage = useAppPersistenceStore((state) => state.appLanguage);
  const setLongVideos = useFeedStore((state) => state.setLongVideos);
  const longVideos = useFeedStore((state) => state.longVideos);
  const currentLongVideoSelected = useFeedStore((state) => state.currentLongVideoSelected);
  const hasUserLoggedIn = useProfileStore((state) => state.hasUserLoggedIn);
  const { push } = useRouter();
  const fetchingDataRef = useRef(false);
  const [commentsData, setCommentsData] = useState<IFeedOrStreamComment[]>([]);
  // console.log("Comment data => ", threads);
  const [showFullContentArray, setShowFullContentArray] = useState<boolean[]>([]);
  const paginate = useRef({
    start: 0,
    count: 10,
  });
  const userProfile = useProfileStore((state) => state.userProfile);
  const [keyboardStatus, setKeyboardStatus] = useState<number>(0);
  const theme = useTheme();
  const hasLoggedIn = hasUserLoggedIn();
  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;

  useEffect(() => {
    let showSubscription;
    let hideSubscription;
    if (useKeyBoardHeight) {
      showSubscription = Keyboard.addListener('keyboardDidShow', (e) => {
        setKeyboardStatus(e?.endCoordinates?.height);
      });
      hideSubscription = Keyboard.addListener('keyboardDidHide', (e) => {
        setKeyboardStatus(e?.endCoordinates?.height);
      });
    }

    return () => {
      if (useKeyBoardHeight) {
        showSubscription.remove();
        hideSubscription.remove();
      }
    };
  }, []);


  const handleCommentEvent = (feedDetail) => {
    const description = `${feedDetail?.description?.replace(/(<a.*?href="([^"]+)".*?<\/a>)|<[^>]*>/g, '')}`;
    const truncatedDescription =
      description && description.length > 100 ? `${description.substring(0, 100)}...` : description;

      const additionalDetails = [
        addEventParam('postOwnerId', feedDetail?.postOwnerId),
        addEventParam('actionBy', userProfile?.user?.name ?? '-1'),
        addEventParam('postTitle', truncatedDescription),
      ];
      const commentEvent :INinjaEvent = {
        name:  KissanEventType.ITEM_COMMENT,
        screenDetails: { screen: 'comment section' },
        eventParams: additionalDetails,
      };
      enqueue(commentEvent);
      handleMarketingEvents(KissanEventType.ITEM_COMMENT, {screen:'short video'},additionalDetails);
  };

  const addComment = async () => {
    if (!hasUserLoggedIn()) {
      handleCommentEvent(feedDetail);
      // onGuestUserBottomSheetOpen();
      // push('/login');
      return;
    }

    if (addcomment.trim()?.length == 0) {
      return;
    }

    const uploadContentApiMutationConfig: any = {
      status: addcomment,
      in_reply_to_id: currentLongVideoSelected?.actionData?.content?.id
        ? currentLongVideoSelected?.actionData?.content?.id
        : feedDetail?.id,
      media_ids: [],
      sensitive: false,
      spoiler_text: '',
      visibility: 'public',
      poll: null,
      language: appLanguage,
    };

    setLoading(true);
    try {
      let res;
      let shortComment: IVideosThreds = {
        total: 0,
        data: [],
      };
      if (feedDetail?.id) {
        res = await postCommentOnVideo(feedDetail?.id.toString(), addcomment);
        shortComment.data = [res?.comment];
        shortComment.total = 0;
        // updateShortVideo(feedDetail as IESShortVideoContent, index);
      }
      else {
        handleCommentEvent(feedDetail);
        res = await uploadContentApi(uploadContentApiMutationConfig);
      }
      

      if (res) {
        setLoading(false);
        const commentValueData = transformStreamComment(shortComment)
        // setThreads((prevThreads) => [...prevThreads, commentValueData]);
        setComment('');
        fetchingDataRef.current = false;
        const newCommentList = [...commentValueData, ...commentsData];
        setCommentsData([...newCommentList]);
        if (textAreaRef.current) {
          textAreaRef.current.clear();
        }
        const index = longVideos.findIndex((item) => item.id === commentValueData[0]?.id);
        if (index !== -1) {
          const updatedLongVideos = [...longVideos];
          updatedLongVideos[index].comments_count += 1;
          setLongVideos(updatedLongVideos);
        }
        setCommentsCount(commentsCount + 1);
      }
    } catch (error) {
      setLoading(false);
    }
    Keyboard.dismiss();
  };

  useEffect(() => {
    if (feedDetail) {
      commentsData.length = 0;
      paginate.current.start = 0;
      loadCommentsByType(paginate.current.start);
    }
  }, [feedDetail]);

  const loadCommentsByType = async (start: number) => {
    if (!feedDetail) return;
    if (!hasUserLoggedIn()) return;
    // console.log('Feed detail', feedDetail);
    // console.log('calling comments...');
    // setCommentsData([]);
    if (paginate?.current?.start === 0) {
      console.log('Clearing comments....');
      setCommentsData([]);
    }
    try {
      let payload = {
        id: feedDetail?.id,
        start: start,
        count: paginate?.current?.count,
      };
      const res = await getVideoComments(payload);
      if (res && res?.data?.length) {
        setLoading(false);
        const comments = transformStreamComment(res);
        setCommentsData([...commentsData, ...comments]);

        // paginate.current.start += paginate.current.count;
      }
    } catch (error) {
      console.error('On reached comments section data err => ', error);
    } finally {
      // Reset flag after API call is completed
      setLoading(false);
      fetchingDataRef.current = false;
    }
  };

  const onEndReached = async () => {
    paginate.current.start += paginate.current.count;
    await loadCommentsByType(paginate.current.start);
  };

  // const onGuestUserBottomSheetOpen = () => {
  //   setGuestUserbottomSheet(true);
  // };

  // const navigateToLoginPage = () => {
  //   setGuestUserbottomSheet(false);
  //   push('/login');
  // };

  const renderFavouriteCount = (comments) => {
    if (!comments?.likes_count) {
      return <Text>{''}</Text>;
    }
    return (
      <>
        <Card.Footer
          padded
          dsp="flex"
          jc="space-between"
          ai="center"
          borderTopColor={'$grey'}
          borderTopWidth={1}
        >
          <XStack dsp="flex" ai="center" jc="space-between">
            <ThumbsUp />
            <Paragraph ls="$10" ml={8} fs={13} style={{ fontWeight: '500' }}>
              {comments?.likes_count}
            </Paragraph>
          </XStack>
          <XStack dsp="flex" ai="center" jc="space-between">
            <MessageCircle />
            <Paragraph ls="$10" fs={13} style={{ fontWeight: '500' }} color={'$usertextColor'} ml={8}>
              {t('page.replyNow')}
            </Paragraph>
          </XStack>
        </Card.Footer>
      </>
    );
  };

  const renderCommentsHeader = (comments) => {
    return (
      <Card.Header padded dsp="flex">
        <XStack>
          <Avatar circular size="$5" testID="kisan_tId_CommentSection" onPress={() => handleViewProfileClick(comments?.userId)}>
            <Avatar.Image accessibilityLabel={comments?.username} src={comments?.avatar} />
            <Avatar.Fallback delayMs={600} />
          </Avatar>
          <XStack fd="column" pl={10} pt={1}>
            <Paragraph
              fs={16}
              color={'$usertextColor'}
              style={{ fontWeight: '700' }}
              testID="kisan_tId_CommentSection"
              onPress={() => handleViewProfileClick(comments?.userId)}
            >
              {comments?.display_name}
            </Paragraph>
            <Paragraph fs={13} style={{ fontWeight: '500' }} color={'$darkGrey'}>
              {comments?.created_at && useTimeAgo(comments?.created_at)}
            </Paragraph>
          </XStack>
        </XStack>
      </Card.Header>
    );
  };

  const toggleExpansion = (index) => {
    // setShowFullContent(!showFullContent);
    // setShowFullContent(prevState => !prevState);
    setShowFullContentArray((prevState) => {
      const newState = [...prevState];
      newState[index] = !newState[index];
      return newState;
    });
    setCommentsData((prevCommentsData) => {
      const updatedCommentsData = [...prevCommentsData];
      updatedCommentsData[index] = {
        ...updatedCommentsData[index],
        showFullContent: !updatedCommentsData[index]?.showFullContent,
      };
      return updatedCommentsData;
    });
  };

  const renderContent = (comments, index) => {
    if (!comments?.content) return null;
    const maxLength = 100;

    const normalizedContent = `${comments?.content}`;

    const truncatedContent =
      normalizedContent?.length > maxLength
        ? normalizedContent?.substring(0, maxLength) + '...'
        : normalizedContent;

    console.log('Comment content => ', normalizedContent);

    return (
      <Pressable py={5} pl={10} testID="kisan_tId_CommentSection" onPress={() => toggleExpansion(index)}>
        
        <Paragraph color={theme['darkLight']?.val}>
        {showFullContentArray[index] ? normalizedContent : truncatedContent}
        </Paragraph>
        {normalizedContent?.length > maxLength && (
          <Text color={'$primary'}>
            {showFullContentArray[index] ? t('page.readLess') : `${t('page.readMore')}...`}
          </Text>
        )}
      </Pressable>
    );
  };

  const renderCommentItem = ({ item: comments, index }) => {
    return (
      <>
        <Stack key={index} mb={5} px={3} py={'$2'}>
          <Card
            backgroundColor={'$cardbackground'}
            elevate
            size="$2"
            paddingHorizontal="$2"
            br={10}
            paddingTop="$2"
            shadowColor={'$overlaybg'}
            elevation={5}
            shadowOpacity={0.2}
          >
            {renderCommentsHeader(comments)}
            {renderContent(comments, index)}
            {renderFavouriteCount(comments)}
          </Card>
        </Stack>
      </>
    );
  };

  const handleViewProfileClick = (userId) => {
    const isInvalidOwner = isInvalidPostOwnerId(userId);
    const isCurrentUser = userId === userProfile?.user?.id;
    if (isInvalidOwner) return;
    push(isCurrentUser ? '/profileDetail' : `/profile/${userId}`);
    if (setCommentbottomSheet) {
      setCommentbottomSheet(!commentbottomSheet)
    }
  }

  return (
    <View style={{ height: '97%', minWidth: '100%', paddingBottom: 80 }}>
      <FlashList
        data={commentsData}
        renderItem={renderCommentItem}
        keyExtractor={(item, index) => index.toString()}
        estimatedItemSize={200}
        onEndReachedThreshold={0.5}
        showsVerticalScrollIndicator={false}
        onEndReached={onEndReached}
        ListHeaderComponent={() => (
          <Paragraph
            marginTop={20}
            marginBottom={10}
            fontSize={18}
            fontWeight={'600'}
            paddingHorizontal={8}
            style={{ flex: 1, height: 'auto', alignItems: 'center' }}
          >
            {t('page.comments')}
          </Paragraph>
        )}
      />

      {loading && (
        <Stack dsp="flex" jc="center" ai="center" mb={5} mt={0} px={30} py={'$2'}>
          <Spinner
            visible={loading}
            textContent={t('page.loading')}
            textStyle={{ color: '#368665' }}
            size="large"
          />
        </Stack>
      )}
      {!loading && (!commentsData || commentsData.length === 0) && (
        <View style={{ flex: 1, alignItems: 'center', marginTop: 30 }}>
          <Paragraph fontSize={20} fontWeight={'600'} paddingVertical={2} color={'$primary'}>
            {t('page.noCommentsYet')}
          </Paragraph>
        </View>
      )}
      {hasLoggedIn && (
        <YStack
          height={45}
          marginRight={10}
          position="absolute"
          bottom={bottom}
          width={'100%'}
          style={{ marginBottom: Platform.OS === 'ios' ? 25 : 0 }}
        >
          <XStack
            flexDirection="row"
            alignItems="center"
            borderTopColor={'#EEE'}
            borderTopWidth={1}
            width={'100%'}
            backgroundColor={'$inputBg'}
          >
            <XStack width={'92%'} backgroundColor={'$inputBg'} marginTop={10}>
              <TextArea
                style={{ borderColor: 'transparent' }}
                placeholder={t(`page.typeYourCommentHere`)}
                backgroundColor={'$inputBg'}
                onChangeText={(text) => setComment(text)}
                ref={textAreaRef}
                placeholderTextColor={'$grey'}
                color={'$color'}
                padding={10}
                fontSize={16}
                height={80}
                width={'100%'}
                testID="kisan_tId_CommentSectionInput"
              />
            </XStack>
            <XStack width={'10%'} testID="kisan_tId_CommentSection" onPress={addComment} backgroundColor={'$inputBg'}>
              <Stack
                borderRadius={50}
                borderWidth={1}
                borderColor={'rgba(115, 115, 115, 0.40)'}
                backgroundColor={addcomment.trim()?.length != 0 ? '$primary' : '$grey'}
                padding={8}
                w={40}
                height={40}
                marginTop={15}
                testID='kisan_tId_CommentSectionSendButton'
              >
                <SendHorizontal color={'#FFF'} size={22} />
              </Stack>
            </XStack>
          </XStack>
        </YStack>
      )}
    </View>
  );
};